import FiservIpgSection from './FiservIpgSection';
export default FiservIpgSection;
